import {defineBrandPage} from '../../../brand/components/BrandPage'

// TODO: Add the homepage Contentful fields once the final mapping is approved.
export const homePage = defineBrandPage({})
